import { Divider } from 'antd';

export const InsightPlaceholder = () => (
  <div className="insight-placeholder-container">
    <Divider />
    <img src="/img/insight_home.png" alt="Select insight" />
    <h2>Select an insight to begin your research.</h2>
  </div>
);
